import { createSlice } from "@reduxjs/toolkit";

export interface FoundationState {
  value: number;
}

const initialState: FoundationState = {
  value: 0,
};

const foundationSlice = createSlice({
  name: "foundation",
  initialState,
  reducers: {
    increment(state) {
      state.value += 1;
    },
    reset(state) {
      state.value = initialState.value;
    },
  },
});

export const { increment, reset } = foundationSlice.actions;

export const selectFoundationValue = (state: { foundation: FoundationState }) =>
  state.foundation.value;

export default foundationSlice.reducer;
